import { Ajax } from '@AJAX'
import { app } from '@/main'
import Cookie from '@GUTIL/cookie.js'
import {
  setStorage,
  getStorage,
  removeAllStorage,
  urlReplace,
  setDefaultRefreshData
} from '@GUTIL/other'

const setURL = (url, service) => {
  let serv = service || ''
  const env = process.env.NODE_ENV === 'localhost' ? '' : '/apis/v1'
  return `${serv}/public${env}/${url}`
}
// 區分平台 Operator | Department
const loginType = process.env.FOLDER_NAME === 'operator' ? 1 : 2

// Cookie 的時效
const expires = new Date(
  new Date().getTime() + 10 * 24 * 30 * 60 * 60 * 1000
).toUTCString()

const login = async params => {
  /**
   * 需要的參數
   * @async
   * @param {string} username  帳號
   * @param {string} password 密碼
   * @param {number} type
   * @param {object} links
   * @param {string} links.otpBindURL // 前往綁定otp qrcode
   * @param {string} links.otpVerifyURL // 前往驗證otp
   * @param {string} links.resourceURL // 萬用密碼直接回首頁
   */
  const { formData, isRemember } = params
  const {
    data: { data, meta = {} },
    isError,
    code
  } = await Ajax('post', setURL('auth/login'), {
    ...formData,
    type: loginType
  })

  if (!isError) {
    isRemember
      ? Cookie.set('user', formData.username, expires)
      : Cookie.remove('user')
  }
  if (!isError && meta.toLink === 'Home') {
    initToken(data)
  }

  return { isError, code, toLink: meta.toLink, params: data }
}

const otpVerify = async params => {
  /**
   * 需要的參數
   * @async
   * @param {string} identityUUID
   * @param {string} otpCode
   * @param {number} type
   * @param {object} links
   * @param {string} links.resetPasswordURL // 首次登入，前往綁定頁
   * @param {string} links.resourceURL // 萬用密碼？
   */

  const {
    data: { data, meta = {} },
    isError,
    code
  } = await Ajax('post', setURL('auth/otp'), {
    ...params,
    type: loginType
  })

  const isFirst = meta.toLink !== 'Home'
  if (!isError && !isFirst) {
    initToken(data)
  }

  return {
    isError,
    code,
    toLink: meta.toLink,
    params: data
  }
}

const forgetPassword = async params => {
  /**
   * 需要的參數
   * @async
   * @param {string} username
   * @param {string} otpCode
   * @param {object} links
   * @param {string} links.resetPasswordURL // 重置密碼
   */

  const {
    data: { data },
    code,
    isError
  } = await Ajax('post', setURL('auth/password/resetinfo'), {
    ...params,
    type: loginType
  })
  return {
    isError,
    code,
    toLink: !isError ? 'PasswordReset' : '',
    params: !isError ? data : {}
  }
}

const resetPassword = async params => {
  /**
   * 需要的參數
   * @async
   * @param {string} identityUUID
   * @param {string} requestToken
   * @param {string} password
   */

  const {
    isError,
    code,
    data: { data }
  } = await Ajax('post', setURL('auth/password/reset'), {
    ...params,
    type: loginType
  })

  return {
    isError,
    code,
    toLink: !isError ? 'PasswordResetSuccess' : '',
    params: !isError ? data : {}
  }
}

const resetOtp = async (params, opts = {}) => {
  /**
   * 需要的參數
   * @async
   * @param {string} identityUUID
   * @param {string} name
   */
  const { isError, code } = await Ajax(
    'post',
    setURL('auth/otp/reset'),
    params,
    opts
  )
  return { isError, code, toLink: !isError ? 'OtpResetSuccess' : '' }
}

const logout = async () => {
  const token = getStorage('access_token')
  if (token) {
    const logoutURL = urlReplace(setURL('auth/logout/{token}'), {
      token
    }).replace('Bearer ', '')

    await Ajax('get', logoutURL, {}, { excludeRefreshToken: true })
  }
  removeAllStorage()
  app.$router.push({ name: 'Login' })
}

// Refresh token
const refreshToken = async params => {
  const refreshUrl = urlReplace('auth/token/refresh/{token}', {
    token: params
  })
  const {
    data: { data = {} },
    isError
  } = await Ajax('get', setURL(refreshUrl))
  if (isError) {
    console.log(isError)
    await logout()
  } else {
    setStorage('access_token', `Bearer ${data.accessToken}`)
    setDefaultRefreshData(data)
  }
  return data
}

const exchangeRefreshToken = async () => {
  let checkData = getStorage('check_data') || null
  if (checkData) {
    const { refreshToken: _refreshToken, waringTimestamp } = checkData
    const nowTimestamp = new Date().getTime()
    const inWaringInterval = waringTimestamp && nowTimestamp > waringTimestamp
    return !inWaringInterval || (await refreshToken(_refreshToken))
  }
}

const initToken = async data => {
  setStorage('access_token', `Bearer ${data.accessToken}`) // 尚未重設密碼，不能直接登入
  setDefaultRefreshData(data)
  await app.$store.dispatch(_GM.SET_LOGIN_ACCOUNT_INFO)
}

export default {
  login,
  otpVerify,
  forgetPassword,
  resetPassword,
  resetOtp,
  logout,
  refreshToken,
  exchangeRefreshToken,
  initToken
}
